export const date = (input: string, option: { year: boolean } = { year: true }) => {
  return Intl.DateTimeFormat('default', {
    month: 'short',
    ...(option.year ? { year: 'numeric' } : {}),
    day: 'numeric',
  }).format(new Date(input))
}
export const capitalize = (input: string): string => (input ? `${input[0].toUpperCase()}${input.slice(1)}` : '')

export function nFormatter(num: number, digits: number) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  const item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value
    })
  return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0'
}

export const balanceFormat = (balance: any) => balance?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const breadcrumbFromUrl = (pageUrl: string, pageName: string) => {
  const pathSegments = new URL(pageUrl).pathname
    .split('/')
    .filter(Boolean)
    .map((segment, index) =>
      index === 0 && segment.toLowerCase() === 'maplestory' ? 'MapleStory' : capitalize(segment),
    )
  const breadcrumbs = [...pathSegments, pageName]
  return breadcrumbs.join(' > ')
}

export const getYoutubeId = (url: string) => {
  const value = url.trim()
  if (!value) return ''
  if (!value.includes('://')) return value
  try {
    const url = new URL(value)
    if (url.hostname.includes('youtube.com')) {
      return url.searchParams.get('v') || value
    }
    if (url.hostname.includes('youtu.be')) {
      return url.pathname.replace(/^\/+/, '').split('/')[0] || value
    }
    return value
  } catch {
    return value
  }
}

/**
 * Appends (or replaces) `utm_content` on an absolute URL, preserving any query string it already has.
 * Relative or malformed URLs are returned untouched rather than throwing — a broken link is worse
 * than a missing UTM tag.
 */
export const urlWithUtmContent = (url: string, utmContent: string): string => {
  try {
    const parsed = new URL(url)
    parsed.searchParams.set('utm_content', utmContent)
    return parsed.toString()
  } catch {
    return url
  }
}
